module.exports = __webpack_public_path__ + "img/title-image.bba555be.png";